<div *ngIf="isAuthenticated" class="container">
  <app-welcome></app-welcome>
</div>

<div *ngIf="!isAuthenticated" class="container">
  <app-login></app-login>
</div>
